import { useEffect, useState } from "react";
import { Button } from "../../styles/Button.styled";
import { fetchUploadedDocuments } from "../../../api/api";
import { Col, Row } from "antd";
import DocUploadDropZone from "../UploadZone";
import { docPageHeader, renderDepositWaiverSuccess } from "../textContent";
import { useTranslation } from "react-i18next";
import Thankyou from "../../../pages/thankyou";
import { useNavigate } from "react-router";
import { docUploadStyles } from "./UploadPage";
import DepositAlternative from "../../depositWaiver/DepositAlternative";

const DepositWaiverUploadScreen = ({
  additional,
  enrollmentTokens,
  selectedPlans,
  showFinalPage,
  autopayRequired,
}: {
  additional: any;
  enrollmentTokens: any;
  selectedPlans: any;
  showFinalPage?: any;
  autopayRequired?: any;
}) => {
  const [uploadComplete, setUploadComplete] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [cancelled, setCancelled] = useState(false);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation("enrollment");
  const { t: tCommon } = useTranslation("common");

  useEffect(() => {
    (async () => {
      try {
        // await fetchDocs();
      } catch (err) {
        setUploadComplete(false);
      }
    })();
  }, [enrollmentTokens?.productId]);

  const fetchDocs = async () => {
    setLoading(true);
    try {
      const url = new URL(window.location.href);
      const idParam = url.searchParams.get("id");
      const signParam = url.searchParams.get("sign");

      const res = await fetchUploadedDocuments(
        enrollmentTokens?.enrollment_id || idParam,
        enrollmentTokens?.sign || signParam
      );
      if (res.status === 200 && res.files.length > 0) {
        setUploadComplete(true);
      }
    } catch (err) {
      setUploadComplete(false);
    }
    setLoading(false);
  };

  if (cancelled) {
    return <Thankyou />;
  }

  return (
    <div>
      <Row justify="center">
        <Col>
          <h1 style={{ fontSize: 24, fontWeight: 700 }}>{docPageHeader}</h1>
        </Col>
      </Row>
      <Row justify="center">
        <Col span={24}>
          <h1 className="mb-3 text-center">{t("We are Almost There!")}</h1>
        </Col>
        <Col style={{ fontWeight: 400, fontSize: 16 }}>
          <p style={{ fontSize: 16, fontWeight: "bold", textAlign: "center" }}>
            {t("depositWaiverDocTitle")}
          </p>
          <span className="upload-files-sublabel">
            <DepositAlternative />
          </span>
        </Col>
      </Row>
      <Row justify="center" className="dropzone-section">
        <Col span={24}>
          {loading ? (
            <div style={{ textAlign: "center" }}>Loading...</div>
          ) : uploadComplete ? (
            <div style={{ color: "green", textAlign: "center" }}>
              {renderDepositWaiverSuccess(tCommon)}
            </div>
          ) : (
            <div style={docUploadStyles}>
              <DocUploadDropZone
                fetchDocs={fetchDocs}
                docFor="waiver"
                setCancelled={setCancelled}
                payDepositButton={() => (
                  <>
                    <Button
                      style={{
                        marginRight: "1rem",
                        background: "transparent",
                        color: "#253f66",
                      }}
                    >
                      <span onClick={() => navigate(-1)}>
                        {t("Pay Deposit")}
                      </span>
                    </Button>
                  </>
                )}
              />
            </div>
          )}
        </Col>
      </Row>
      <Row
        justify="center"
        align={"middle"}
        style={{ margin: "20px 0", display: "flex", flexDirection: "column" }}
      >
        <Col>
          <Button
            withArrow
            style={{ minWidth: "20rem" }}
            onClick={() => {
              window.location.href =
                i18n.language === "en"
                  ? `https://cleanskyenergy.com/`
                  : `https://cleanskyenergy.com/es`;
            }}
          >
            {t("Back to Homepage")}
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default DepositWaiverUploadScreen;
